export const removerDuplicatas = (array: number[]) => {
  // Usando Set para remover duplicatas
  const conjuntoSemDuplicatas = new Set(array);
  // Convertendo o Set de volta para um array
  const arraySemDuplicatas = Array.from(conjuntoSemDuplicatas).sort(
    (a, b) => a - b,
  );
  return arraySemDuplicatas;
};
